import {
  ApolloClient,
  from,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { MMKVWrapper, persistCache } from 'apollo3-cache-persist';
import React from 'react';
import {
  createAuthLink,
  createErrorLink,
  createHttpLink,
  createRetryLink,
} from 'utils/apolloClientUtils';
import { cacheSettings } from 'utils/cacheUtils';
import { MMKVStorage } from 'utils/MMKVStorage';

const useCreateApolloClient = () => {
  const [client, setClient] =
    React.useState<ApolloClient<NormalizedCacheObject>>();

  React.useEffect(() => {
    const createApolloClient = async () => {
      const cache = new InMemoryCache(cacheSettings);
      await persistCache({
        cache,
        storage: new MMKVWrapper(MMKVStorage),
        debug: process.env.NODE_ENV !== 'production',
        maxSize: false,
      });
      const httpLink = createHttpLink();
      const retrylink = createRetryLink();
      const authLink = createAuthLink();
      const errorLink = createErrorLink();

      const persistedClient = new ApolloClient({
        link: from([errorLink, authLink, retrylink, httpLink]),
        cache,
      });

      setClient(persistedClient);
    };
    createApolloClient();

    return () => {
      setClient(undefined);
    };
  }, []);

  return client;
};

export default useCreateApolloClient;
